var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-85d846d2","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 472
// module chunks = 0